import React from 'react'
// libs
import styled from 'styled-components'
import { useQuery } from '@apollo/client/react'
// components
import Tree from 'components/Tree'
import LoaderWithOverlay from 'components/UI/Loader/LoaderWithOverlay'
// constant
import { ENTITIES } from 'constants/entities'
// graphql
import { BUSINESS_UNITS_HIERARCHY_QUERY } from 'graphql/businessUnit/queries'
// themes
import { REACT_SORTABLE_TREE_STYLES } from 'themes'
// icons
import ViewModuleIcon from '@mui/icons-material/ViewModuleRounded'
// utils
import get from 'lodash/get'

const TreeWrapper = styled.div`
  height: 100%;

  .node-content-wrapper {
    pointer-events: none;
  }
`

const reorderChildren = (arr) => {
  return arr.map((parent) => {
    if (parent.children) {
      parent.children.sort((a) => (a.type === ENTITIES.PLAN ? -1 : 1))
      reorderChildren(parent.children)
    }
    return parent
  })
}

const BusinessUnitsHierarchyTree: React.FC = () => {
  const { data: hierarchyQuery, loading: isLoading } = useQuery(BUSINESS_UNITS_HIERARCHY_QUERY, {
    fetchPolicy: 'network-only'
  })

  const data = get(hierarchyQuery, 'businessUnitsHierarchy.data', []).map((item) => ({
    ...item,
    title: item.description,
    noDragging: true,
    expanded: true,
    icon: item.type === ENTITIES.PLAN ? <ViewModuleIcon /> : null,
    onClick:
      item.type === ENTITIES.PLAN
        ? () =>
            window.open(
              `/plans/${item.planId}?companyId=${item.planCompanyId}&parentId=${item.planParentPlanId}`,
              '_blank'
            )
        : null
  }))

  if (isLoading) {
    return <LoaderWithOverlay isLoading height={'calc(100% - 50px)'} />
  }

  return (
    <TreeWrapper>
      {/*//@ts-ignore*/}
      <Tree
        source={data}
        isLoading={isLoading}
        normalizeData={reorderChildren}
        reactVirtualizedListProps={{
          style: REACT_SORTABLE_TREE_STYLES
        }}
      />
    </TreeWrapper>
  )
}

export default BusinessUnitsHierarchyTree
